// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Structure Type Selector - Theme-Aware */

.structure-type-selector {
  background: var(--cfn-popup-bg);
  border-radius: 12px;
  box-shadow: var(--cfn-popup-shadow);
  border: 1px solid var(--cfn-border);
  min-width: 320px;
  max-width: 380px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: var(--cfn-text-primary);
}

/* Header */
.structure-type-selector__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-header-bg);
  border-left: 3px solid var(--cfn-success);
  border-radius: 12px 12px 0 0;
}

.structure-type-selector__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--cfn-success) 0%, #059669 100%);
  box-shadow: var(--cfn-shadow-md);
  flex-shrink: 0;
}

.structure-type-selector__icon i {
  font-size: 18px;
  color: #ffffff;
}

.structure-type-selector__title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--cfn-text-primary);
}

.structure-type-selector__subtitle {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: var(--cfn-text-muted);
}

/* Types Grid */
.structure-type-selector__types {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 16px;
}

/* Type Buttons */
.structure-type-selector__type-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 12px;
  border: 1px solid var(--cfn-border);
  border-radius: 10px;
  background: var(--cfn-btn-secondary-bg);
  color: var(--cfn-text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.structure-type-selector__type-btn:hover {
  transform: translateY(-2px);
  background: var(--cfn-btn-secondary-hover-bg);
  border-color: var(--cfn-border-strong);
  box-shadow: var(--cfn-shadow-md);
}

.structure-type-selector__type-btn i {
  font-size: 28px;
}

/* Footer */
.structure-type-selector__footer {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-footer-bg);
  border-radius: 0 0 12px 12px;
}

.structure-type-selector__footer-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid var(--cfn-border);
  border-radius: 8px;
  background: var(--cfn-btn-secondary-bg);
  color: var(--cfn-text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.structure-type-selector__footer-btn:hover {
  background: var(--cfn-btn-secondary-hover-bg);
}

.structure-type-selector__footer-btn--danger {
  background: var(--cfn-danger-muted);
  border-color: var(--cfn-btn-danger-border);
  color: var(--cfn-danger-text);
}

.structure-type-selector__footer-btn--danger:hover {
  background: var(--cfn-btn-danger-hover-bg);
}

/* Leaflet popup wrapper */
.leaflet-popup-content-wrapper.structure-type-selector-wrapper {
  background: transparent;
  padding: 0;
  box-shadow: none;
  border-radius: 12px;
}

.leaflet-popup-content-wrapper.structure-type-selector-wrapper .leaflet-popup-content {
  margin: 0;
  width: auto !important;
}

.leaflet-popup-tip-container.structure-type-selector-tip {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/structure-type-selector.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,8EAA8E;EAC9E,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,sCAAsC;EACtC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wEAAwE;EACxE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,6CAA6C;EAC7C,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Structure Type Selector - Theme-Aware */\n\n.structure-type-selector {\n  background: var(--cfn-popup-bg);\n  border-radius: 12px;\n  box-shadow: var(--cfn-popup-shadow);\n  border: 1px solid var(--cfn-border);\n  min-width: 320px;\n  max-width: 380px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--cfn-text-primary);\n}\n\n/* Header */\n.structure-type-selector__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-header-bg);\n  border-left: 3px solid var(--cfn-success);\n  border-radius: 12px 12px 0 0;\n}\n\n.structure-type-selector__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, var(--cfn-success) 0%, #059669 100%);\n  box-shadow: var(--cfn-shadow-md);\n  flex-shrink: 0;\n}\n\n.structure-type-selector__icon i {\n  font-size: 18px;\n  color: #ffffff;\n}\n\n.structure-type-selector__title h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--cfn-text-primary);\n}\n\n.structure-type-selector__subtitle {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: var(--cfn-text-muted);\n}\n\n/* Types Grid */\n.structure-type-selector__types {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  padding: 16px;\n}\n\n/* Type Buttons */\n.structure-type-selector__type-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 20px 12px;\n  border: 1px solid var(--cfn-border);\n  border-radius: 10px;\n  background: var(--cfn-btn-secondary-bg);\n  color: var(--cfn-text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.structure-type-selector__type-btn:hover {\n  transform: translateY(-2px);\n  background: var(--cfn-btn-secondary-hover-bg);\n  border-color: var(--cfn-border-strong);\n  box-shadow: var(--cfn-shadow-md);\n}\n\n.structure-type-selector__type-btn i {\n  font-size: 28px;\n}\n\n/* Footer */\n.structure-type-selector__footer {\n  display: flex;\n  gap: 8px;\n  padding: 12px;\n  border-top: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-footer-bg);\n  border-radius: 0 0 12px 12px;\n}\n\n.structure-type-selector__footer-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: 1px solid var(--cfn-border);\n  border-radius: 8px;\n  background: var(--cfn-btn-secondary-bg);\n  color: var(--cfn-text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.structure-type-selector__footer-btn:hover {\n  background: var(--cfn-btn-secondary-hover-bg);\n}\n\n.structure-type-selector__footer-btn--danger {\n  background: var(--cfn-danger-muted);\n  border-color: var(--cfn-btn-danger-border);\n  color: var(--cfn-danger-text);\n}\n\n.structure-type-selector__footer-btn--danger:hover {\n  background: var(--cfn-btn-danger-hover-bg);\n}\n\n/* Leaflet popup wrapper */\n.leaflet-popup-content-wrapper.structure-type-selector-wrapper {\n  background: transparent;\n  padding: 0;\n  box-shadow: none;\n  border-radius: 12px;\n}\n\n.leaflet-popup-content-wrapper.structure-type-selector-wrapper .leaflet-popup-content {\n  margin: 0;\n  width: auto !important;\n}\n\n.leaflet-popup-tip-container.structure-type-selector-tip {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
